import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../tokens.service";

const authConfig = () => ({
  headers: {
    Authorization: "Bearer " + getAgenteAccessToken(),
    "Content-Type": "application/json",
  },
});

export const getRecordatorioList = async (body) => {
  const response = await mainAxios.post(
    "/v1/recordatorio/list",
    body,
    authConfig(),
  );
  return response.data;
};

export const insertRecordatorio = async (body) => {
  const serverResponse = await mainAxios.post(
    "/v1/recordatorio/insert",
    body,
    authConfig(),
  );
  return serverResponse.data;
};

export const updateRecordatorio = async (id, body) => {
  const serverResponse = await mainAxios.put(
    `/v1/recordatorio/update/${id}`,
    body,
    authConfig(),
  );
  return serverResponse.data;
};
